import CachedIcon from '@mui/icons-material/Cached';
import { IconButton, IconButtonProps } from '@mui/material';

export type RefreshButtonProps = IconButtonProps;

const RefreshButton: React.FC<RefreshButtonProps> = (props) => {
  return (
    <IconButton {...props}>
      <CachedIcon fontSize={props.size} />
    </IconButton>
  );
};

export default RefreshButton;
